<template>
  <a @click.prevent.stop="update" :class="{'is-activeTri' : privateSort}">
    <slot :text="label">
      <span>
        {{ label }}
      </span>
      <span class="icon is-pulled-right" v-if="privateSort">
        <i :class="{[iconAsc]: privateOrder === 'asc', [iconDesc]: privateOrder === 'desc'}"></i>
      </span>
      <span class="icon is-pulled-right" v-else>
        <i class="fas fa-sort-amount-down"></i>
      </span>
    </slot>
  </a>
</template>

<script>
  export default {
    name: 'Sortable',
    data () {
      return {
        privateOrder: 'asc',
        privateSort: false
      }
    },
    props: {
      sort: {
        required: false
      },
      label: {
        type: String,
        required: false,
        default: 'sortable'
      },
      iconAsc: {
        type: String,
        default: 'fas fa-sort-amount-down'
      },
      iconDesc: {
        type: String,
        default: 'fas fa-sort-amount-up'
      }
    },
    watch: {
      sort (to) {
        this.privateOrder = to.order
        this.privateSort = to.sort
      }
    },
    methods: {
      update () {
        this.privateSort = true
        this.privateOrder = (this.privateOrder === 'asc') ? 'desc' : 'asc'
        this.$emit('sort', {order: this.privateOrder, sort: this.privateSort})
      }
    },
    created () {
      this.privateSort = (this.sort) ? this.sort.sort : undefined
      this.privateOrder = (this.sort) ? this.sort.order : undefined
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/Sortable.vue